// 每日吃瓜网 - 栏目与文章数据（纯静态展示数据）
// 说明：本文件仅存放展示用数据，不含逻辑。

export type Block = { t: 'p' | 'h' | 'quote' | 'list'; d: string | string[] };

export interface Article {
  slug: string;
  category: string;
  title: string;
  summary: string;
  date: string;
  readMin: number;
  views: number;
  hot?: boolean;
  tags: string[];
  hero: string;
  body: Block[];
}

export interface Category {
  slug: string;
  name: string;
  tagline: string;
  desc: string;
  role: 'primary' | 'accent' | 'secondary';
  icon: string;
  cover: string;
}

export const categories: Category[] = [
  {
    slug: 'tafang',
    name: '塌房现场',
    tagline: '人设崩塌第一现场',
    desc: '从偷税、假唱到道德争议，记录明星光环破碎的每一个瞬间，复盘"塌房"背后的来龙去脉。',
    role: 'primary',
    icon: 'ri-fire-line',
    cover: 'https://readdy.ai/api/search-image?query=dark%20editorial%20portrait%20of%20a%20cracked%20glowing%20billboard%20with%20a%20broken%20celebrity%20silhouette%2C%20dramatic%20red%20rim%20light%20and%20smoke%2C%20newspaper%20headline%20paper%20texture%2C%20high%20contrast%20stylized%20cinematic%20look%2C%20moody%20and%20gritty&width=720&height=900&seq=cat-tafang&orientation=portrait',
  },
  {
    slug: 'lianqing',
    name: '恋情实锤',
    tagline: '爱豆绯闻追踪簿',
    desc: '同框路透、同款细节、时间线复盘，从蛛丝马迹到实锤画面，一步步揭开爱豆感情的真面目。',
    role: 'accent',
    icon: 'ri-heart-3-fill',
    cover: 'https://readdy.ai/api/search-image?query=romantic%20pink%20glowing%20neon%20hearts%20over%20a%20blurred%20night%20city%20street%2C%20two%20distant%20silhouettes%20walking%20together%2C%20soft%20bokeh%20lights%2C%20warm%20dreamy%20editorial%20aesthetic%2C%20cinematic%20color%20grade&width=720&height=900&seq=cat-lianqing&orientation=portrait',
  },
  {
    slug: 'juzu',
    name: '剧组爆料',
    tagline: '片场秘密档案',
    desc: '选角换角、搭档关系、替身幕后，把摄影棚里不为人知的那一面摊开给你看。',
    role: 'secondary',
    icon: 'ri-clapperboard-line',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20film%20set%20with%20clapperboard%20and%20studio%20lights%20casting%20long%20shadows%2C%20tripod%20and%20camera%20silhouette%2C%20moody%20green%20teal%20and%20amber%20lighting%2C%20behind%20the%20scenes%20editorial%20photography&width=720&height=900&seq=cat-juzu&orientation=portrait',
  },
  {
    slug: 'zongyi',
    name: '综艺幕后',
    tagline: '节目剧本显微镜',
    desc: '从赛制设计到剪辑逻辑，逐帧拆解综艺里那些"刚刚好"的巧合与剪辑出来的真实。',
    role: 'secondary',
    icon: 'ri-tv-2-line',
    cover: 'https://readdy.ai/api/search-image?query=television%20studio%20stage%20with%20bright%20spotlights%20and%20audience%20silhouettes%2C%20director%20monitor%20in%20foreground%2C%20electric%20violet%20and%20cyan%20light%20beams%2C%20backstage%20atmosphere%2C%20modern%20variety%20show%20set&width=720&height=900&seq=cat-zongyi&orientation=portrait',
  },
  {
    slug: 'hongtan',
    name: '红毯名场面',
    tagline: '星光与翻车都在这里',
    desc: '造型盘点、惊艳与惊险并存，红毯上每一次闪光灯亮起的瞬间，都有故事可聊。',
    role: 'accent',
    icon: 'ri-camera-3-fill',
    cover: 'https://readdy.ai/api/search-image?query=glamorous%20red%20carpet%20night%20scene%20with%20photographer%20flash%20lights%20and%20golden%20bokeh%2C%20elegant%20silhouette%20walking%20under%20spotlight%2C%20opulent%20dark%20background%20with%20warm%20amber%20glow%2C%20editorial%20fashion%20photography&width=720&height=900&seq=cat-hongtan&orientation=portrait',
  },
];

export const articles: Article[] = [
  {
    slug: 'tafang-toushui',
    category: 'tafang',
    title: '一线男星被曝补缴上亿税款，"良心老板"人设崩得彻底',
    summary: '从镜头前的大方老板到被曝偷税漏税、补缴上亿，这位一线男星的口碑为何一夜崩盘？我们梳理了整件事的完整时间线。',
    date: '2026-09-09',
    readMin: 6,
    views: 128940,
    hot: true,
    tags: ['塌房', '税务', '人设崩塌'],
    hero: 'https://readdy.ai/api/search-image?query=dramatic%20editorial%20photography%20of%20a%20crumbling%20glowing%20billboard%20with%20torn%20celebrity%20poster%2C%20piles%20of%20documents%20and%20calculator%20in%20shadow%2C%20deep%20red%20and%20dark%20tonal%20palette%2C%20newsroom%20mood%2C%20high%20contrast%20cinematic%20lighting&width=1200&height=720&seq=art-tafang-tax&orientation=landscape',
    body: [
      { t: 'p', d: '这段时间最热闹的瓜，莫过于这位一线男星因税务问题被推上风口浪尖。消息一出，曾经整齐划一的"口碑广场"瞬间分裂，粉丝和路人吵成一片，话题热度一度占据娱乐榜前几位，久久不散。' },
      { t: 'p', d: '事情要从一份网传的内部核查名单说起。名单显示该艺人名下关联的多家公司，在过去数年间被指通过拆分收入、虚列成本等方式，少申报了大量应纳税所得额。爆料人还晒出部分经打码的票据截图，指向性相当明确。' },
      { t: 'h', d: '从"最大方老板"到舆论翻车，中间只隔了一份报表' },
      { t: 'p', d: '讽刺的是，这位男星此前最出圈的标签，正是出手阔绰、善待工作人员。无论是剧组开机时给群演发红包，还是自掏腰包给团队加餐，他"良心老板"的形象经营多年，路人缘一直不错。可当镜头外的财务真相浮出水面，人设与现实的落差被瞬间放大。' },
      { t: 'quote', d: '"镜头前的慷慨是营业，账本上的缺口才是底牌。"这句话被大量转发，成为本瓜最扎心的一条评论。' },
      { t: 'p', d: '目前经纪公司尚未正面回应，只留下一句"正在了解情况"。但粉丝内部已经开始分化：有人坚持"等官方"，也有人坦言"累了，脱粉"。至于后续是否补税、处罚几何，还要看权威部门怎么说。' },
    ],
  },
  {
    slug: 'tafang-jiachang',
    category: 'tafang',
    title: '顶流巡演被质疑假唱？现场音频对比疑点重重',
    summary: '一场场座无虚席的巡演，却被观众扒出多个"对不上嘴型"的瞬间。现场音频与技术流对比，让假唱争议越烧越旺。',
    date: '2026-09-08',
    readMin: 5,
    views: 98420,
    hot: true,
    tags: ['假唱', '巡演', '实锤争议'],
    hero: 'https://readdy.ai/api/search-image?query=concert%20stage%20with%20giant%20microphone%20silhouette%20in%20front%20of%20confetti%20and%20purple%20red%20spotlights%2C%20crowd%20with%20phone%20lights%2C%20audio%20waveform%20overlay%20in%20air%2C%20dynamic%20music%20concert%20editorial%20mood&width=1200&height=720&seq=art-tafang-sing&orientation=landscape',
    body: [
      { t: 'p', d: '演唱会市场大热的当下，假唱质疑一直是悬在艺人头上的达摩克利斯之剑。而这一次，争议集中落在了一位连开数十场、场场爆满的顶流歌手身上。' },
      { t: 'p', d: '起因是有观众晒出多段现场直拍：在高难度的快歌段落里，歌手的口型与歌声存在明显错位，副歌的喘息声也"精准得不像真人"。相关视频被搬运后迅速传播，几个"扒谱"和"比对音轨"的博主紧随其后上线分析。' },
      { t: 'h', d: '技术流"锤"出了什么' },
      { t: 'list', d: ['多段不同场次的现场收音中，人声部分存在一致的、几乎无误差的稳定性，被质疑与录音室版本高度吻合；', '高难度跳跃与动作段落，气口仍保持清晰饱满，被指"不科学"；', '个别跑调段落却"恰巧"出现在远景机位，近景特写又回到完美状态。'] },
      { t: 'quote', d: '"要么是神仙体能，要么是 CD 精修。"这类评论下，点赞最高的一条写着：观众掏的是真金白银，听的是现场，而不是音响里播的母带。' },
      { t: 'p', d: '争议尚未有官方结论，主办方与歌手本人均未正面辟谣。但可以想见，无论结果如何，"现场真唱"这个命题，都会在之后的演出中被反复拿来拷问。' },
    ],
  },
  {
    slug: 'tafang-mofu',
    category: 'tafang',
    title: '昔日模范夫妻官宣离婚，多年"恩爱剧本"终究落幕',
    summary: '结婚多年、镜头前羡煞旁人的一对明星夫妻，终于在深夜发布联合声明。回看两人的互动，其实早有蛛丝马迹。',
    date: '2026-09-06',
    readMin: 7,
    views: 151200,
    hot: true,
    tags: ['离婚', '模范夫妻', '声明'],
    hero: 'https://readdy.ai/api/search-image?query=melancholic%20editorial%20image%20of%20two%20wedding%20rings%20separating%20apart%20on%20dark%20fabric%20under%20cold%20amber%20light%2C%20rose%20petals%20scattered%2C%20paper%20with%20official%20stamp%2C%20sad%20moody%20cinematic%20tonal%20composition&width=1200&height=720&seq=art-tafang-divorce&orientation=landscape',
    body: [
      { t: 'p', d: '深夜的联合声明来得突然，却又在不少人的预料之中。这对以"模范夫妻"著称的明星夫妇宣布结束多年的婚姻，声明措辞客气而克制，只强调"和平分手、共同抚养孩子"。' },
      { t: 'p', d: '消息瞬间刷屏。毕竟他们曾是综艺、访谈里最常被拿出来当"爱情范本"的一对，从相识、相恋到公开，每一段都被做成高甜合辑反复传播。' },
      { t: 'h', d: '回看过去一年，伏笔其实不少' },
      { t: 'list', d: ['共同出席的公开活动明显减少，近半年几乎零同框；', '以往雷打不动的生日零点祝福，今年双双缺席；', '女方近期的采访避谈家庭话题，只以"顺其自然"带过。'] },
      { t: 'quote', d: '有网友总结得很精辟："恩爱人设就像一期节目，再长也有播完的那天。"' },
      { t: 'p', d: '婚姻是私事，外人本不该多加评判。但作为吃瓜群众，我们更该关心的，其实是那些把"夫妻恩爱"当成长期营业剧本的现象本身。当真情与剧本的边界越来越模糊，塌的就不只是这一对。' },
    ],
  },
  {
    slug: 'lianqing-tongchuang',
    category: 'lianqing',
    title: '爱豆恋情实锤？深夜同回公寓画面曝光',
    summary: '先是同款、再是同机，如今深夜同回公寓的画面被镜头定格。这一次，恋情实锤还能再躲多久？',
    date: '2026-09-09',
    readMin: 4,
    views: 142300,
    hot: true,
    tags: ['恋情实锤', '同框', '爱豆'],
    hero: 'https://readdy.ai/api/search-image?query=night%20street%20surveillance%20style%20shot%20of%20two%20people%20in%20hoodies%20walking%20into%20an%20apartment%20building%20entrance%2C%20paparazzi%20flash%20shadow%2C%20pink%20neon%20accent%20light%2C%20cinematic%20grainy%20documentary%20feel&width=1200&height=720&seq=art-love-home&orientation=landscape',
    body: [
      { t: 'p', d: '恋情瓜一旦开了头，基本就是连环炸。此前被拍到"同款项链""同款帽子"的两位爱豆，这次直接被镜头定格在了深夜同回公寓的画面里。' },
      { t: 'p', d: '据现场画面，两人先后从同一辆车下来，一前一后保持着距离，却还是被眼尖的镜头捕捉到上了同一部电梯。这样的"避嫌式同框"，在追星圈里几乎等于默认。' },
      { t: 'h', d: '粉丝的反应两极化' },
      { t: 'list', d: ['一部分粉丝选择祝福，认为成年爱豆恋爱无可厚非；', '另一部分则情绪激动，觉得偶像失格，要求工作室回应；', '还有"吃瓜路人"忙着翻两人的时间线，越扒越甜。'] },
      { t: 'quote', d: '"比起恋爱本身，更让粉丝破防的往往是被一瞒再瞒的体验。"' },
      { t: 'p', d: '截至目前双方公司均未发声，只留下一句意味深长的"艺人的私生活请勿过多猜测"。可镜头里那一幕已经说明一切——这场实锤，怕是躲不掉了。' },
    ],
  },
  {
    slug: 'lianqing-juzufuqi',
    category: 'lianqing',
    title: '"剧组夫妻"修成正果？片场亲密路透疯传',
    summary: '连续两部戏合作、戏里戏外都甜到发腻，这对"剧组夫妻"被曝已经牵手。究竟是营业还是真爱？',
    date: '2026-09-07',
    readMin: 5,
    views: 87900,
    tags: ['剧组夫妻', '路透', '合作'],
    hero: 'https://readdy.ai/api/search-image?query=behind%20the%20scenes%20shot%20of%20actors%20sharing%20an%20umbrella%20between%20takes%20on%20a%20film%20set%2C%20warm%20golden%20hour%20light%2C%20soft%20heart%20shaped%20bokeh%20in%20background%2C%20romantic%20cinematic%20photography&width=1200&height=720&seq=art-love-set&orientation=landscape',
    body: [
      { t: 'p', d: '"剧组夫妻"这个词在圈内历来微妙。它可以是惺惺相惜的默契，也可能是营业捆绑的戏码。而最近这对因连续合作两部戏而圈粉无数的搭档，似乎正从"戏里的甜"走向"戏外的真"。' },
      { t: 'p', d: '起因是片场休息时的一段路透视频：两人共用一把伞、自然地交换保温杯，肢体语言亲昵却不刻意。比起剧宣时摆拍的生硬，这种不经意的细节往往最有说服力。' },
      { t: 'h', d: '合作节奏快得不寻常' },
      { t: 'p', d: '业内人士也爆料，两人不仅连续搭戏，还在团队层面高度绑定——同一位造型团队、同一个宣发节奏，甚至连休息档期都尽量错开安排在同一时段。如此步调，很难说只是普通同事。' },
      { t: 'quote', d: '有资深追剧博主写道："真正的甜蜜藏不住，营业感再强也盖不住眼里的光。"' },
      { t: 'p', d: '当然，在没有当事人开口之前，一切仍是猜测。可对嗑上头的观众来说，这段"剧组夫妻"能否修成正果，已经成了当下最想追完的一部"番外剧"。' },
    ],
  },
  {
    slug: 'lianqing-waiyou',
    category: 'lianqing',
    title: '顶流女星与圈外男友低调相恋三年，首次被拍同框',
    summary: '一段藏了三年的恋情，终于在机场安检口的偶遇中被揭开。圈外人男友身份成谜，却获粉丝一致好感。',
    date: '2026-09-05',
    readMin: 4,
    views: 76200,
    tags: ['顶流女星', '圈外男友', '同框'],
    hero: 'https://readdy.ai/api/search-image?query=airport%20terminal%20scene%20with%20two%20people%20in%20casual%20wear%20walking%20side%20by%20side%20carrying%20luggage%2C%20soft%20morning%20window%20light%2C%20subtle%20pink%20and%20gold%20tone%2C%20candid%20cinematic%20photography&width=1200&height=720&seq=art-love-airport&orientation=landscape',
    body: [
      { t: 'p', d: '娱乐圈里，能把恋爱藏三年不露风声的，多少有点本事。而这位顶流女星不仅做到了，还把这段关系经营得异常低调又稳固。' },
      { t: 'p', d: '一切始于机场的一次偶然偶遇。有网友在安检通道拍下一对并肩而行的男女，其中女方正是那位当红女星。令人意外的是，她身旁的男子并未刻意遮挡镜头，反而自然地帮她整理背包带，动作熟稔得像相处多年的老夫老妻。' },
      { t: 'h', d: '圈外人男友，凭什么获得好感' },
      { t: 'list', d: ['全程没有蹭镜头、没有营销通稿，低调到尘埃里；', '被扒出是素人背景，从未借"男友"身份博关注；', '多次被目击接送探班，却从未留下刻意摆拍。'] },
      { t: 'quote', d: '"不立人设、不炒作、不消费女友流量，反而是内娱最稀缺的男友模板。"' },
      { t: 'p', d: '面对外界关注，女星工作室只回应"感谢关心，请给私人空间"。这份克制，反倒让更多路人吃下这颗"岁月静好"的糖。也许真正的恋情实锤，并不需要轰轰烈烈，稳定本身就足以说明一切。' },
    ],
  },
  {
    slug: 'juzu-xuancai',
    category: 'juzu',
    title: '大IP选角内幕：临开机前主角为何大换血',
    summary: '被溜粉三年、官宣又撤宣，这部万众期待的大IP为何在开机前夜换了男女主？知情人的爆料拼出了选角江湖的真实规则。',
    date: '2026-09-08',
    readMin: 7,
    views: 113500,
    hot: true,
    tags: ['选角', '大IP', '内幕'],
    hero: 'https://readdy.ai/api/search-image?query=film%20casting%20table%20with%20actor%20headshots%20and%20script%20pages%20under%20a%20desk%20lamp%2C%20producer%20silhouette%20looking%20over%20a%20giant%20casting%20call%20board%2C%20moody%20teal%20and%20amber%20lighting%2C%20industry%20backstage%20editorial%20feel&width=1200&height=720&seq=art-juzu-cast&orientation=landscape',
    body: [
      { t: 'p', d: '一部头部 IP 的改编剧，从立项起就吊足了全网胃口。先后被"溜"过名字的演员能排成两桌麻将，粉丝之间更是为了"饼"到底归谁撕得不可开交。' },
      { t: 'p', d: '可就在万众期待、官宣在即时，剧组却突然宣布男女主全部更换。消息一出，原著粉和待爆粉丝集体懵了，纷纷追问：好好的主角，怎么说换就换？' },
      { t: 'h', d: '知情人拆解选角江湖的几条潜规则' },
      { t: 'list', d: ['平台与制片方对"扛剧能力"的评估往往压倒原著适配度，资历浅的演员随时可能被更有流量的名字顶替；', '档期撞车是常态，多位原定主演在开机前因排期谈不拢遗憾退出；', '试镜后的片酬与商务捆绑谈崩，也是临阵换角的高发原因。'] },
      { t: 'quote', d: '一位不愿透露姓名的选角导演感叹："观众以为选角是拼演技，其实大多时候拼的是排期、报价和平台关系。"' },
      { t: 'p', d: '换角风波背后，真正被忽略的是作品本身。当一个个角色沦为资本博弈的棋子，我们追的究竟是故事，还是流量们的人设排位？这或许是比"谁演"更值得掰扯的问题。' },
    ],
  },
  {
    slug: 'juzu-tishen',
    category: 'juzu',
    title: '替身演员自述：威亚安全不该只靠"命大"',
    summary: '在聚光灯照不到的片场角落，替身演员拿命博镜头。一位从业十余年的武替，用亲身经历说出了行业最沉重的隐忧。',
    date: '2026-09-04',
    readMin: 6,
    views: 65100,
    tags: ['替身', '行业', '安全'],
    hero: 'https://readdy.ai/api/search-image?query=stunt%20double%20hanging%20on%20wire%20rig%20silhouette%20against%20studio%20green%20screen%20lights%2C%20safety%20harness%20and%20climbing%20gear%20closeup%2C%20dramatic%20directional%20lighting%2C%20behind%20the%20scenes%20documentary%20photography&width=1200&height=720&seq=art-juzu-stunt&orientation=landscape',
    body: [
      { t: 'p', d: '动作戏里最惊险的飞檐走壁、坠楼翻车，往往由一群连正脸都很少被记住的替身演员完成。当观众为"主演亲身上阵"点赞时，真正的风险却常常由替身承担。' },
      { t: 'p', d: '一位从业超过十五年的武术替身老周，在采访中聊起了自己最不愿回忆的一次意外。"那场威亚戏，设备上个月就该检修，组里拖了又拖。结果下坠时钢索差点断裂，我在半空缓冲了半秒，才捡回一条命。"' },
      { t: 'h', d: '"命大"不该成为行业的兜底' },
      { t: 'list', d: ['威亚与吊臂未按周期送检，靠经验"赌"安全；', '高强度连拍导致替身疲劳，而临时找来的替身缺乏专项训练；', '出事后常被要求"息事宁人"，赔偿方案模糊不清。'] },
      { t: 'quote', d: '"我们不是不怕死，是怕死得不明不白。"老周说，替身也是影视工业的一环，不该被当成可以随意消耗的耗材。' },
      { t: 'p', d: '一次次的"有惊无险"，不该被当作茶余饭后的谈资。只有当安全规范真正落地、每个替身都被当成主角来保护，那些惊险镜头背后的人，才配得上掌声。' },
    ],
  },
  {
    slug: 'zongyi-juben',
    category: 'zongyi',
    title: '综艺"剧本痕迹"太重？这档竞演节目的巧合被扒穿',
    summary: '每一次淘汰都精准踩在热搜节点上？观众把整季赛程重看一遍后，发现所谓的"意外爆冷"其实环环相扣。',
    date: '2026-09-09',
    readMin: 6,
    views: 134800,
    hot: true,
    tags: ['综艺剧本', '竞演', '赛制'],
    hero: 'https://readdy.ai/api/search-image?query=television%20competition%20stage%20with%20rankings%20board%20and%20spotlights%2C%20hand%20pointing%20at%20elimination%20list%2C%20clapperboard%20and%20script%20pages%20scattered%2C%20electric%20amber%20and%20magenta%20light%2C%20behind%20the%20scenes%20of%20a%20variety%20show&width=1200&height=720&seq=art-show-script&orientation=landscape',
    body: [
      { t: 'p', d: '竞技类综艺最吸引人的，是那种"不到最后一刻不知结果"的紧张感。可当观众把整季回放一遍，却发现节目里的"意外"越来越不意外。' },
      { t: 'p', d: '以这档正在热播的竞演节目为例：每位被淘汰的选手，几乎都卡在自己的话题热度即将退潮的节点上；而每一轮"爆冷"，又都精准地落在节目组需要的宣传拐点上。巧合多了，就成了必然。' },
      { t: 'h', d: '"剧本痕迹"都藏在哪' },
      { t: 'list', d: ['所谓"盲投"的结果，与节目外粉丝投票趋势存在明显错位；', '关键反转镜头给到的时间点，与热搜投放节奏几乎同步；', '导师的争议发言总在收视低谷期出现，被质疑"故意制造冲突"。'] },
      { t: 'quote', d: '"观众不是看不出剧本，只是愿意配合演出。"这句话点破了看综艺最微妙的心理。' },
      { t: 'p', d: '当然，综艺要编排、要叙事，本身无可厚非。可当"真人秀"里的真实越缩越小，留下的就只剩一套又一套的模板。吃瓜归吃瓜，这份对"真实"的较真，或许才是观众最该守住的东西。' },
    ],
  },
  {
    slug: 'zongyi-jianji',
    category: 'zongyi',
    title: '剪辑师爆料：你以为的"真实反应"，大多是被剪出来的',
    summary: '一句无关紧要的话、一个随手的表情，经剪辑之手就能变成"高能名场面"。一位从业十年的综艺剪辑师揭开了蒙太奇的魔法。',
    date: '2026-09-03',
    readMin: 5,
    views: 82800,
    tags: ['剪辑', '综艺', '幕后'],
    hero: 'https://readdy.ai/api/search-image?query=video%20editing%20suite%20with%20multiple%20monitors%20showing%20timeline%20and%20faces%2C%20editor%20hands%20on%20keyboard%2C%20amber%20desk%20lamp%20and%20purple%20screen%20glow%2C%20montage%20film%20strips%20on%20wall%2C%20dark%20professional%20studio%20atmosphere&width=1200&height=720&seq=art-show-edit&orientation=landscape',
    body: [
      { t: 'p', d: '很多观众以为，真人秀里嘉宾的每一句妙语、每一个神级反应都是现场自然发生的。但在从业十年的综艺剪辑师小林看来，镜头前的"真实"，有时是剪刀手一点点拼出来的。' },
      { t: 'p', d: '"剪辑是戴着镣铐跳舞。"小林说，一段两小时的正片背后，往往躺着几十个小时的原始素材。而如何在这些素材里"讲故事"，决定权在剪辑台上，而不在现场。' },
      { t: 'h', d: '几个最常见的"剪辑魔法"' },
      { t: 'list', d: ['把嘉宾相隔数小时的两次叹气拼在一起，就成了"全程兴致不高"的人设；', '用一句前后不搭的"爆点"台词做预告，正片却轻描淡写带过；', '给某位嘉宾反复切"憋笑"特写，硬是把中性反应剪成戏剧冲突。'] },
      { t: 'quote', d: '"导演要的是冲突，我们只能给冲突。"小林坦言，剪辑师不是恶人，只是这份工作天然要求他们选择性呈现。' },
      { t: 'p', d: '当"人设"越来越多地被剪辑定义，所谓的"综艺剧本痕迹"，与其说是白纸黑字的剧本，不如说是一种无处不在的"素材再创作"。看清了这层，再吃综艺的瓜，或许就能多一分平常心。' },
    ],
  },
  {
    slug: 'hongtan-chuanfa',
    category: 'hongtan',
    title: '红毯翻车名场面：造型师手滑，她穿成"窗帘布"',
    summary: '红毯是名利场，也是试金石。同一件高定，穿好了封神，穿翻了就成了被玩坏的"窗帘布"。回顾那些让人脚趾抠地的造型瞬间。',
    date: '2026-09-08',
    readMin: 5,
    views: 101600,
    tags: ['红毯', '造型', '翻车'],
    hero: 'https://readdy.ai/api/search-image?query=fashion%20disaster%20editorial%20shot%20of%20a%20dramatic%20oversized%20gown%20with%20exaggerated%20fabric%20drapes%20like%20curtains%20on%20a%20red%20carpet%2C%20photographers%20flashing%2C%20satirical%20fashion%20magazine%20style%2C%20warm%20stage%20lights&width=1200&height=720&seq=art-red-carpet-dress&orientation=landscape',
    body: [
      { t: 'p', d: '红毯永远是一台大型"造型斗兽场"。有人凭一件礼服封神，也有人因一次失手被群嘲一整年。而最经典的翻车名场面，往往不是款式本身丑，而是"人穿衣服"变成了"衣服穿人"。' },
      { t: 'p', d: '就拿某次电影节来说，一位女星选择了一条面料垂坠感极强的拼接长裙。原版模特图是利落的建筑感剪影，可她一上身，层层叠叠的布料堆在腰胯处，硬生生撑成了"行走的窗帘布"。镜头一到，评论区立刻炸了锅。' },
      { t: 'h', d: '为什么同一条裙子，效果天差地别' },
      { t: 'list', d: ['高定礼服大多按标准身材裁版，明星本人身高、肩颈比例若不匹配，极易穿出"挂布"感；', '面料光泽与现场镁光灯相互作用，精修图与生图往往判若两人；', '最关键的，是造型师是否针对艺人气质量身做了调整与试穿。'] },
      { t: 'quote', d: '"衣服是死的，人是活的。翻车，大多翻在【不合适】三个字上。"一位造型顾问如此总结。' },
      { t: 'p', d: '不过，被群嘲的"窗帘布"女星后来在采访里的自嘲倒是相当圈粉："红毯嘛，本来就是大型翻车现场，谁还没个穿错的时候。"这份坦然，反而比任何华服都更耐看。' },
    ],
  },
  {
    slug: 'hongtan-ganchuan',
    category: 'hongtan',
    title: '谁最敢穿？今年颁奖礼红毯上的惊险穿搭盘点',
    summary: '开叉到腰、镂空到背、材质反光到刺眼——今年颁奖礼红毯集体"放飞自我"。大胆背后，是审美的胜利还是眼球的较量？',
    date: '2026-09-06',
    readMin: 6,
    views: 89300,
    tags: ['颁奖礼', '红毯', '穿搭'],
    hero: 'https://readdy.ai/api/search-image?query=glamorous%20red%20carpet%20awards%20night%20with%20daring%20cutout%20gowns%20and%20bold%20reflective%20fabrics%2C%20photographers%20and%20golden%20bokeh%2C%20vivid%20amber%20and%20deep%20red%20lighting%2C%20high%20fashion%20editorial%20photography&width=1200&height=720&seq=art-red-carpet-bold&orientation=landscape',
    body: [
      { t: 'p', d: '如果说电影节红毯比的是优雅，那么颁奖礼红毯，比的往往就是谁更"敢"。今年的几场大型颁奖礼，明星们集体把大胆写在了身上，尺度与话题度齐飞。' },
      { t: 'p', d: '有女星一条高叉长裙从腰际直开而上，每走一步都像在挑战镜头的极限；也有男星大胆尝试透视叠穿与高饱和撞色，把"男性荷尔蒙"玩出了新花样。热搜词条更是一个接一个：敢穿、惊艳、还是"看不懂"？' },
      { t: 'h', d: '大胆着装，是自信还是炒作' },
      { t: 'list', d: ['支持者认为，红毯本就是展示个性与审美自由的舞台，敢穿是自信的表现；', '质疑者则指出，部分造型明显奔着"博眼球上热搜"而去，与作品和实力关系不大；', '而时尚圈更在意的是：这种大胆是否真的穿出了高级感，还是只停在"博出位"。'] },
      { t: 'quote', d: '一位时尚评论人写道："真正的敢穿，是衣服为个性服务；而假的敢穿，是人为衣服打工。"' },
      { t: 'p', d: '审美没有标准答案，但"敢穿"与"穿得对"之间那条线，值得每个人反复掂量。今年的红毯虽然争议不断，却也实实在在地把穿搭这门功课，推到了聚光灯下。' },
    ],
  },
];

export const trendingHeadlines = [
  '顶流巡演假唱争议持续发酵，多个现场直拍被疯转',
  '一线男星补缴上亿税款，经纪公司回应"正在了解"',
  '深夜同回公寓，这对爱豆的恋情实锤还能躲多久？',
  '大IP临开机换角，原著粉集体破防',
  '红毯"窗帘布"造型被群嘲，当事人自嘲圈粉',
  '模范夫妻官宣离婚，多年恩爱剧本落幕',
  '综艺剪辑师爆料：你以为的真实反应大多是被剪出来的',
  '剧组夫妻连续两部戏绑定，片场路透甜度超标',
];

export const trendingList = [
  { rank: 1, title: '顶流巡演"假唱"实锤争议：现场音频对比疑点重重', views: 142300, tag: '实锤', category: 'tafang', slug: 'tafang-jiachang' },
  { rank: 2, title: '一线男星补缴上亿税款，"良心老板"人设崩得彻底', views: 128940, tag: '塌房', category: 'tafang', slug: 'tafang-toushui' },
  { rank: 3, title: '爱豆恋情实锤？深夜同回公寓画面曝光', views: 116700, tag: '恋情', category: 'lianqing', slug: 'lianqing-tongchuang' },
  { rank: 4, title: '大IP选角内幕：临开机前主角为何大换血', views: 113500, tag: '剧组', category: 'juzu', slug: 'juzu-xuancai' },
  { rank: 5, title: '综艺"剧本痕迹"太重？这档竞演节目被扒穿', views: 99800, tag: '综艺', category: 'zongyi', slug: 'zongyi-juben' },
  { rank: 6, title: '红毯翻车名场面：她穿成"窗帘布"仍自嘲圈粉', views: 88200, tag: '红毯', category: 'hongtan', slug: 'hongtan-chuanfa' },
];